module.exports = __webpack_public_path__ + "static/media/unity.c2dcbbaa.png";